import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CmsService, RoutingService, StateWithCms } from '@spartacus/core';

@Injectable({
    providedIn: 'root',
})
export class AimoCmsService extends CmsService {
    constructor(store: Store<StateWithCms>, routingService: RoutingService) {
        super(store, routingService);
    }
}
